"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
function getLink(lang) {
    switch (lang) {
        case 'fi':
            return 'https://www.sokopro.com/myynti/';
        case 'sv':
            return 'https://www.sokopro.com/sv/saljavdelning/';
        case 'dk':
            return 'https://www.sokopro.com/da/salg/';
        case 'de':
            return 'https://www.sokopro.com/de/vertrieb/';
        case 'ru':
            return 'https://www.sokopro.com/ru/sales/';
        case 'ee':
            return 'https://www.sokopro.com/et/muuk/';
        default:
            return 'https://www.sokopro.com/en/sales/';
    }
}
var component = function (props) { return (React.createElement("div", { className: 'sso-benefits' },
    React.createElement("h2", null, (0, translation_1.getLocalization)('sso/benefits/whatIs/header')),
    React.createElement("p", null, (0, translation_1.getLocalization)('sso/benefits/whatIs/text')),
    React.createElement("hr", { className: 'title' }),
    React.createElement("h2", null, (0, translation_1.getLocalization)('sso/benefits/header')),
    React.createElement("div", { className: 'section' },
        React.createElement("div", { className: 'image' },
            React.createElement("img", { src: '/assets/sso/rocket_blue.svg' })),
        React.createElement("h3", null, (0, translation_1.getLocalization)('sso/benefits/fasterLogin/header')),
        React.createElement("p", { className: 'text' }, (0, translation_1.getLocalization)('sso/benefits/fasterLogin/text'))),
    React.createElement("div", { className: 'section' },
        React.createElement("div", { className: 'image' },
            React.createElement("img", { src: '/assets/sso/admin_blue.svg' })),
        React.createElement("h3", null, (0, translation_1.getLocalization)('sso/benefits/reduceAdministration/header')),
        React.createElement("p", { className: 'text' }, (0, translation_1.getLocalization)('sso/benefits/reduceAdministration/text'))),
    React.createElement("div", { className: 'section' },
        React.createElement("div", { className: 'image' },
            React.createElement("img", { src: '/assets/sso/shield_blue.svg' })),
        React.createElement("h3", null, (0, translation_1.getLocalization)('sso/benefits/increaseDataSecurity/header')),
        React.createElement("p", { className: 'text' }, (0, translation_1.getLocalization)('sso/benefits/increaseDataSecurity/text'))),
    React.createElement("div", { className: 'section' },
        React.createElement("div", { className: 'image' },
            React.createElement("img", { src: '/assets/sso/contact_blue.svg' })),
        React.createElement("h2", null, (0, translation_1.getLocalization)('sso/contact/header')),
        React.createElement("a", { className: 'text', href: getLink(props.selectedLanguage) }, (0, translation_1.getLocalization)('sso/contact/link'))))); };
exports.default = component;
